






import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import pc from './pc/login.vue';
import movil from './movil/login.vue';

@Component( {
    name: "Componente",
    props: {},
    components: { pc, movil }
} )
export default class Componente extends Vue
{

    constructor()
    {
        super();
        //this.$EventBus.setTitulo( 'Cursos' );
    }

}
